export default {
  autoUpdate: 'Aktualizovať automaticky (každch {0})',
  updateInterval: 'Interval aktualizcie',
  lastUpdate: 'Posledn aktualizcia',
  nextUpdate: 'Ďalšia aktualizácia za {0}',
};
